/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  TableRow,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { getWorkerIMTimeRole } from "services/workerSchedule";

import { getWorkersByMgr, getParentManager } from "services";
import { getEndOfWeek, isEmptyObject } from "utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { MANAGE_TIMESHEET } from "navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
import SectionHead from "../../../src/components/SectionHead";
import { properCase } from "utils";
import { AccessTime as Watch, DateRange, Close } from "@material-ui/icons";
import { KeyboardTimePicker, KeyboardDatePicker } from "@material-ui/pickers";
import { isDateValid } from "../../../src/utils/index";

const useStyles = makeStyles((theme) => ({
  selectedWorker: {
    backgroundColor: theme.palette.action.selected,
    textAlign: "center",
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.primary.main,
  },
  TSApprovedStatus: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    color: "#388e3c",
  },
  tansactional: {
    color: "#1B75BC",
  },
  nonTransactional: {
    color: "#00A88E",
  },
  project: {
    color: "#6DCFF6",
  },
  buildingMoves: {
    color: "#3C5772",
  },
  meal: {
    color: "#58595B",
  },
  leave: {
    color: "#58595B",
  },
}));

const Controls = (props) => {
  const {
    setLoading,
    locationProps,
    workerName,
    loggedInSupervisor,
    setSelectWorker,
    loggedInUser,
    loadTimeLineView,
    selectedDate,
    setSelectedDate,
    SetIsViewDisabled,
    isViewDisabled,
    setTimeLineViewData,
  } = props;
  // console.log("activityGroupTotals:", activityGroupTotals);
  const classes = useStyles();
  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState("");
  const { user } = useSelector((state) => state.user.auth);
  const [districts, setDistricts] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [selectedManager, setSelectedManager] = useState({});
  const [newOptions, setNewOptions] = useState([]);
  const [imtRole, setImtRole] = useState("");
  const [loggedinPlusDelegate, setLoggedinPlusDelegate] = useState([]);
  const [allApprovers, setAllApprovers] = useState([]);
  const history = useHistory();
  const appConfig = useSelector((state) => state.appConfig);
  const { selectedManagerForApproval } = useSelector(
    (state) => state.appConfig
  );

  const { selectedWeekOnReview } = useSelector((state) => state.appConfig);
  const [selectDateErr, setSelectDateErr] = React.useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (user.workerId && appConfig && appConfig.managerEmails !== null) {
      const userManagerObject = {
        managerCountry: user.country,
        managerEmail: user.email,
        managerFirstName: user.firstName,
        managerId: user.workerId,
        managerLastName: user.lastName,
      };

      let delegateManagerList = appConfig.managerEmails.filter(manager => 
        user.delegateFor && user.delegateFor.includes(manager.managerId));

      setSelectedManager(userManagerObject);

      getWorkerIMTimeRole(user.workerId).then((data) => {
        setImtRole(data.role);
      });
      getParentManager(user.workerId).then((querySnapshot) => {
        let optionsAvailable = appConfig.managerEmails.filter(
          (elem) =>
            querySnapshot.findIndex(
              (obj) => obj.managerId === elem.managerId
            ) >=0
        );
        setNewOptions([...new Set([...optionsAvailable,...delegateManagerList]) ]);
      });
    }
  }, [user,appConfig.managerEmails]);

  useEffect(() => {
    if (user) {
      let loggedinCountryManagers = managerOptions.filter(
        (item) => item.managerCountry === user.country
      );

      let totalManagers = [...loggedinCountryManagers, ...newOptions];

      const userManagerObject = {
        managerCountry: user.country,
        managerEmail: user.email,
        managerFirstName: user.firstName,
        managerId: user.workerId,
        managerLastName: user.lastName,
      };

      totalManagers.push(userManagerObject);

      let removeRepeated = totalManagers.filter(
        (elem, index) =>
          totalManagers.findIndex((obj) => obj.managerId === elem.managerId) ===
          index
      );

      setLoggedinPlusDelegate(removeRepeated);
      setAllApprovers(managerOptions);
    }
  }, [newOptions]);

  useEffect(() => {
    if (appConfig && appConfig.managerEmails !== null) {
      let managerDetails = appConfig.managerEmails;
      managerDetails = managerDetails.filter(
        (record) => record.managerId !== user.workerId
      );
      setManagerOptions(managerDetails);
    }
  }, [user, appConfig.managerEmails]);

  const manageForOptions = () => {
    switch (imtRole) {
      case "Admin":
        return allApprovers;
        break;
      case "Super User":
        return loggedinPlusDelegate;
        break;
      case "Supervisor":
        return newOptions;
        break;
      default:
        return newOptions;
    }
  };

  useEffect(() => {
    // Get all My Workers
    console.log("selectedManager ", selectedManager);
    if (selectedManager && selectedManager.managerId && imtRole && user && loggedInUser) {
      console.log("trell", locationProps);
      let userWorkerId = selectedManager.managerId;
      setSelectedWorker("");
      setSelectWorker("");
      setLoading(true);
      //show the selected worker on timesheet page
      if (locationProps && locationProps.worker) {
        console.log("trell 1", locationProps);
        userWorkerId = locationProps.worker.managerId;
      }
      //from all selection
      if (locationProps && locationProps.workers.length != 0) {
        console.log("trell 2", locationProps);
        userWorkerId = locationProps.workers[0].managerId;
      }
      if (
        locationProps &&
        locationProps.workers &&
        locationProps.workers.length == 0
      ) {
        console.log("trell 3", locationProps);
        userWorkerId = selectedManagerForApproval;
      }
      getWorkersByMgr(userWorkerId)
        .then((data) => {
          console.log(
            `getWorkersByMgr for ${selectedManager.managerId} = data=`,
            data
          );
          let active = [];
          //When selectedManager directly navigates to add-timesheet, it should render, if data exists then show that otherwise empty options in worker
          if (data !== false) {
            for (let i = 0; i < data.workers.length; i++) {
              if (data.workers[i].isActiveWorker) {
                active.push(data.workers[i]);
              }
            }
          }
          //sorting the workers name in workers dropdown
          active.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : a.name.toLowerCase() === b.name.toLowerCase()
              ? a.workerId > b.workerId
                ? 1
                : -1
              : -1
          );
          let delegateFor = user?.delegateFor;
          if ((loggedInUser.workerId !== selectedManager.managerId) && (!(delegateFor && selectedManager &&
            delegateFor.includes(selectedManager.managerId))) && ((imtRole && imtRole !== "" && imtRole.toLowerCase() === "supervisor")
              || (!imtRole && loggedInUser && loggedInUser.auth.user.isApprover))) {
            const selManWorkers = active &&
            active.filter(item => item.approvingManager && item.approvingManager.includes(loggedInSupervisor))
            setWorkers(selManWorkers);
          }
          else {
            setWorkers(active);
          }
          setLoading(false);
          if (
            locationProps &&
            locationProps.worker &&
            !locationProps.allPunches
          ) {
            setSelectedWorker(locationProps.worker);
          }

          // dispatch(setAllMyWorkers(data.workers));
        })
        .catch((err) => {
          // setLoading(false);
          console.error("BulkEntry: Err in getWorkerByMgr Response: ", err);
        });
    }
  }, [selectedManager, imtRole, user, loggedInUser]);

  useEffect(() => {
    if (selectedWorker === "" || selectDateErr) {
      SetIsViewDisabled(true);
      setTimeLineViewData(false);
    } else {
      SetIsViewDisabled(false);
    }
  }, [selectedWorker, selectedDate]);

  const activityStartDateChange = (date) => {
    if (
      !moment(date).isValid() ||
      moment(date).isBefore(moment(new Date()).startOf("week")) ||
      moment(date).isAfter(moment(new Date()).endOf("week"))
    ) {
      SetIsViewDisabled(true);
      setTimeLineViewData(false);
      setSelectDateErr(true);
    } else {
      setSelectedDate(date);
      SetIsViewDisabled(false);
      setSelectDateErr(false);
    }
  };

  return (
    <Box
      p={2}
      display="flex"
      flexDirection="row"
      style={{ gap: 16 }}
      alignItems="stretch"
    >
      <Autocomplete
        options={manageForOptions()}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        getOptionLabel={(option) =>
          option && option.managerFirstName
            ? `${option.managerFirstName} ${option.managerLastName} (${option.managerId})`
            : ""
        }
        style={{ minWidth: 200, height: 10 }}
        value={selectedManager}
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setSelectedManager(newValue);
          } else {
            setSelectedManager({});
          }
        }}
        renderInput={(params) => {
          if (isEmptyObject(selectedManager)) {
            return (
              <TextField
                {...params}
                size="small"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                }}
                label={properCase(t("other.lblSelectManager"))}
              />
            );
          } else {
            return (
              <TextField
                {...params}
                size="small"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                }}
                label={properCase(t("other.lblManager"))}
              />
            );
          }
        }}
      />

      <KeyboardDatePicker
        disableBackdropClick
        ampm={false}
        placeholder="dd/MM/yyyy"
        margin="none"
        id="date-picker-dialog"
        format="dd/MM/yyyy"
        value={selectedDate}
        onChange={activityStartDateChange}
        onInputChange={activityStartDateChange}
        minDate={moment(new Date()).startOf("week")}
        maxDate={moment(new Date()).endOf("week")}
        inputVariant="outlined"
        size="small"
        label={properCase(t("pgReview.tableHeads.startDate"))}
        keyboardIcon={<DateRange fontSize="inherit" />}
        helperText={
          selectDateErr && t("pgAddEditPunchSupervisor.lblInvalidDate")
        }
        invalidDateMessage={t("pgAddEditPunchSupervisor.lblInvalidDate")}
        error={selectDateErr}
      />

      <Autocomplete
        // disablePortal
        id="combo-box-demo"
        options={workers}
        getOptionLabel={(option) =>
          option.name ? option.name + " (" + option.workerId + ")" : ""
        }
        style={{ minWidth: 200, height: 10 }}
        value={selectedWorker}
        // defaultValue={{ value: selectedWorker }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderInput={(params) => (
          <TextField
            {...params}
            label={properCase(t("other.lblWorker"))}
            size="small"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
        onChange={(event, newValue) => {
          if (newValue) {
            setSelectedWorker(newValue);
            setSelectWorker(newValue);
          }
        }}
        onInputChange={(event, newValue) => {
          if (!newValue) {
            setSelectedWorker("");
            setSelectWorker("");
          }
        }}
      />
      {workerName && workerName != undefined && (
        <Typography variant="subtitle1" className={classes.selectedWorker}>
          {workerName}
        </Typography>
      )}

      <Grid item>
        <Button
          variant="contained"
          color="primary"
          disableRipple
          disableElevation
          disabled={isViewDisabled}
          size="medium"
          onClick={loadTimeLineView}
        >
         {t("other.lblView")}
        </Button>
      </Grid>
    </Box>
  );
};

export default Controls;
